import keyMirror from "key-mirror";

export const API_BASE_PATH =
  process.env.NODE_ENV !== "production" ? "http://localhost:5000/" : "/";

export const ActionTypesScreenCommon = keyMirror({
  CHANGE_ORIENTATION: null,
  DISPLAY_DATA_SOURCES: null,
  LOG_USER_ACTIVITY : null,
});

export const ActionTypesScreen1 = keyMirror({
  GET_MAPS_DATA: null,
  GET_REGIONS_DATA: null,
  GET_SCORES_DATA: null,
  GET_OUTCOME_DATA: null,
  SET_SELECTED_REGION: null,
  GET_DEMOGRAPHIC_DATA: null,
});

export const ActionTypesScreen2 = keyMirror({
  GET_AVERAGE_DATA: null,
  GET_COUNT_DATA: null,
  GET_PERCENT_DATA: null,
  GET_GROWTH_DATA: null,
  SET_SELECTED_JOB_TYPE_S2: null,
});

export const ActionTypesScreen3 = keyMirror({
  GET_INDSUTRY_DATA: null,
  GET_AVERAGE_DATA_SCREEN3: null,
  GET_AGE_DATA: null,
  GET_RACE_DATA: null,
  GET_GENDER_DATA: null,
  GET_REGIONAL_CONCENTRATION_DATA: null,
  GET_REGIONAL_MIGRATION_DATA: null,
  SET_SELECTED_JOB_TYPE_S3: null,
  SET_SELECTED_INDUSTRY_TYPE_S3: null,
});

export const ActionTypesScreen4 = keyMirror({
  GET_AVERAGE_DATA_SCREEN4: null,
  GET_COUNT_DATA_SCREEN4: null,
  GET_PERCENT_DATA_SCREEN4: null,
  GET_GROWTH_DATA_SCREEN4: null,
});

export const ActionTypesScreen5 = keyMirror({
  GET_OCCUPATION_DATA_SCREEN5: null,
  GET_AVERAGE_DATA_SCREEN5: null,
  GET_INCOME_DATA_SCREEN5: null,
  GET_INCOME_DIFF_DATA_SCREEN5: null,
  GET_AGE_DATA_SCREEN5: null,
  GET_RACE_DATA_SCREEN5: null,
  GET_GENDER_DATA_SCREEN5: null,
  UPDATE_OCCUPATION_TYPE_SCREEN5: null,
});

export const ActionTypesScreen6 = keyMirror({
  GET_AVERAGE_DATA_SCREEN6: null,
  GET_EDUCATION_SUMMARY_DATA_SCREEN6: null,
  GET_EDUCATION_ATTAINMENT_DATA_SCREEN6: null,
  GET_CTE_FILTER_DATA_SCREEN6: null,
  GET_CTE_BAR_CHART_SCREEN6: null,
  GET_CTE_LEFT_SUNBURST_SCREEN6: null,
  GET_CTE_RIGHT_SUNBURST_SCREEN6: null,
  GET_EDUCATION_SUMMARY_CARDS_SCREEN6: null,
  GET_GRAD_POST_SUMMARY_SCREEN6: null,
  GET_GRAD_POST_SUBGROUP_SCREEN6: null,
  GET_NAEP_TABLE_SCREEN6: null,
  GET_COMPLETIONS_OVER_TIME_SCREEN6: null,
  GET_COMPLETIONS_BY_DEGREE_TYPE_SCREEN6: null,
});

export const ActionTypesScreen7 = keyMirror({
  GET_LEFT_MENU_DATA_SCREEN7: null,
  GET_TREE_MAP_DATA_SCREEN7: null,
  GET_BAR_CHART_SCREEN7: null,
  GET_FEEDERS_DATA_SCREEN7: null,
});
